export default __webpack_public_path__ + "static/media/method.34b6b6bb.png";